import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useNetworkName } from "Flocknote/stateHooks";

// pages that set their own title, which this would otherwise overwrite
const SELF_TITLED = ["/giving", "/happes/portal", "/happes/search/v2"];

const DefaultDocumentTitle = () => {
  const { pathname } = useLocation();
  const [networkName] = useNetworkName();

  useEffect(() => {
    const selfTitled = SELF_TITLED.some((path) => pathname.startsWith(path));
    if (!selfTitled && networkName) {
      document.title = `${networkName} // Flocknote`;
    }
  }, [pathname, networkName]);

  return null;
};

export default DefaultDocumentTitle;
